import BookingDiaryUnassignedJobComponentHtml from './booking-diary.unassigned-job.html';

export const BookingDiaryUnassignedJobComponent : ng.IComponentOptions = {
  bindings: {
    index      : '<',
    job        : '=',
    jobStatuses: '<'
  },
  controller : 'BookingDiaryUnassignedJobCtrl',
  templateUrl: BookingDiaryUnassignedJobComponentHtml
};
